export const dynamicPageResolver = location => {
  return {
    'food-truck-catering': {
      'near me': {
        slice_type: 'blob_hero',
        blob_hero_title: `Food truck catering in ${location}`,
        blob_hero_subtitle: `Want wildly creative food trucks serving delicious meals at your next event in ${location}? You’ve come to the right place. Our suppliers are the best in the business! Not only do they bring passion and authenticity to every dish they serve, but their showstopping food trucks provide the ultimate backdrop for any event.`,
      },
      wedding: {
        slice_type: 'blob_hero',
        blob_hero_title: 'Food trucks for your wedding',
        blob_hero_subtitle:
          'Want wildly creative food trucks serving delicious meals at your wedding? You’ve come to the right place. Our suppliers are the best in the business! Not only do they bring passion and authenticity to every dish they serve, but their showstopping food trucks provide the ultimate backdrop for your big day.',
        colour: '#99005d',
      },
    },
    'street-food-catering': {
      parties: {
        slice_type: 'blob_hero',
        blob_hero_title: 'Sensational street food for your party',
        blob_hero_subtitle:
          "Organising a party? Our street food suppliers are guaranteed to impress. From succulent BBQ wraps and woodfired pizzas to chocolatey churros, we'll have the perfect dish for every event. Choose from 1,500+ showstopping street food suppliers today!",
      },
      gourmet: {
        slice_type: 'blob_hero',
        blob_hero_title: 'Gourmet Street Food',
        blob_hero_subtitle:
          'Want wildly creative food trucks serving delicious gourmet food at your next event? You’ve come to the right place. Our suppliers are the best in the business! Not only do they bring passion and authenticity to every dish they serve, but their showstopping food trucks provide the ultimate backdrop for any event.',
      },
    },
    'vegan-catering': {
      vegan: {
        slice_type: 'blob_hero',
        blob_hero_title: 'Vegan Food Trucks',
        blob_hero_subtitle:
          "Whether it's a vegan take on the classic burger, or a mouthwatering spread of the finest vegan options, there's no need to put up with limited choices anymore. Demand for great vegan street food is skyrocketing and our suppliers are leading the charge. So if you're looking for party options, wedding menus and more you're in the right place.",
      },
      'near me vegan': {
        slice_type: 'blob_hero',
        blob_hero_title: `Vegan food truck in ${location}`,
        blob_hero_subtitle: `Whether it's a vegan take on the classic burger, or an amazing spread of the finest vegan options there's no need to put up with limited choices anymore. Demand for great vegan street food is skyrocketing and our suppliers are leading the charge. So if you're looking for party options in ${location}, wedding menus and more you're in the right place.`,
      },
    },
    'vegetarian-catering': {
      vegetarian: {
        slice_type: 'blob_hero',
        blob_hero_title: 'Vegetarian Food Trucks',
        blob_hero_subtitle:
          'Let a veggie menu take centre stage at your party, wedding or event. We have the best vegetarian food trucks and stalls, all dedicated to turning the humble vegetable into a veritable feast. Book the best veggie food vans in the UK today.',
      },
      'near me vegetarian': {
        slice_type: 'blob_hero',
        blob_hero_title: `Vegetarian food trucks in ${location}`,
        blob_hero_subtitle: `Let a veggie menu take centre stage at your party, wedding or event. We have the best vegetarian food trucks and stalls in ${location}, all dedicated to turning the humble vegetable into a veritable feast. Book the best veggie food vans in the UK today.`,
      },
    },
    'halal-catering': {
      halal: {
        slice_type: 'blob_hero',
        blob_hero_title: 'Halal Street Food',
        blob_hero_subtitle:
          "Looking for street food that also offers halal options? Whether it's a party, a wedding or corporate function, hundreds of our suppliers offer delicious halal options for your event.",
      },
      'near me halal': {
        slice_type: 'blob_hero',
        blob_hero_title: `Halal street food in ${location}`,
        blob_hero_subtitle:
          "Looking for local street food that also offers halal options? Whether it's a party, a wedding or corporate function, we have plenty of suppliers in your offering delicious halal options in your area. ",
      },
    },
  };
};
